(function () {
    'use strict';

    angular
        .module('app')
        .controller('SupportController', SupportController);

    SupportController.$inject = ['$rootScope', '$scope', '$location', 'BusinessService', 'MessageService', 'blockUI'];
    function SupportController($rootScope, $scope, $location, BusinessService, MessageService, blockUI) {

        $scope.model = {};

        $scope.params = {
            page: 1,
            count: 10,
            pager_count: [10,20,50,100,200],
        }

        $scope.getPages = getTotalPaginatedPages;
        $scope.getLocalizedPath = getLocalizedPathFromLang;

        var block_messages_list = blockUI.instances.get('messages_list');

        initController();

        // *********************************************************************************************
        //  MAIN PART
        // *********************************************************************************************

        /**
         * Initialize controller
         */
        function initController() {
            getMessages();
        }

        $scope.onReplySend = function () {
            // onReplySubmit(message);
            var post_data = {
                message: $scope.model.message
            }
            if (!$scope.isMessageSent) {
                BusinessService.SendMessageToIncust(post_data, function(success, response){
                    if (success) {
                        $scope.isMessageSent = true;
                        $scope.messagesList.unshift({message: post_data.message, dst_type: 'system', src_type: 'business', created: moment().utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'), readed: 1});
                    }
                });
            }
        };

        $scope.showMessages = function () {
            $location.path('/messages');
        }

        function getMessages() {
            block_messages_list.start();

            var params = {
                page: $scope.params.page,
                count: $scope.params.count,
                date_from: moment('2016-01-01').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                date_to: moment().endOf('day').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]'),
                sort_direction: "DESC",
                sort_field: "created",
                support: true
            };
            
            //params.readed = false;

            MessageService.All(params, function(success, response) {
                if (success) {
                    $scope.messagesList = response.data;
                    $scope.params.summary = response.summary;
                }

                block_messages_list.stop();
            });
        }

        $scope.onNewMessageClick = function () {
            $scope.isMessageSent = false;
            $scope.model.message = '';
        }

        $scope.onMarkAsRead = function (msg) {
            MessageService.MarkAsRead(msg.id, function(success, response) {
                if(success) {
                    getMessages();
                }
            });
        }

        $scope.pageChange = function () {
            getMessages();
        };

        $scope.onCountChange = function (count) {
            $scope.params.page = 1;
            $scope.params.count = count;
            getMessages();
        }

        $scope.openChat = function () {
            window.HelpCrunch('openChat');
        }

    }
})();
